import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoadingDirective } from './loading.directive';
import { LoadingComponent } from './loading.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LoadingDirective,
    LoadingComponent
  ],
  exports: [
    LoadingComponent,
    LoadingDirective
  ]
})
export class LoadingModule { }
